import { Button, Drawer, Empty, List, Typography } from "antd";
import moment from "moment";
import { DATA_FORMATO } from "../../utils";

export const DrawerNaoLidas = ({ visivel, mensagens, onFechar, onAbrir }) => {
  return (
    <Drawer
      title="Mensagens não lidas"
      placement="right"
      width={400}
      visible={visivel}
      onClose={onFechar}
    >
      {mensagens?.length ? (
        <List
          dataSource={mensagens}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button key="abrir" type="link" onClick={() => onAbrir(item)}>
                  abrir
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={item.titulo}
                description={
                  <Typography.Text type="secondary">
                    {item.dataCadastro
                      ? moment(item.dataCadastro).format(`${DATA_FORMATO} HH:mm`)
                      : ""}
                  </Typography.Text>
                }
              />
            </List.Item>
          )}
        />
      ) : (
        <Empty description="Nenhuma mensagem não lida" />
      )}
    </Drawer>
  );
};
